import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	// Log in
	loginFormHeading: {
		id: 'sleep.account.loginFormHeading',
		defaultMessage: 'Log in to start feeling better today',
		description: 'The login form heading for Calm Sleep Premium',
	},
	loginFormHeadingDiscounted: {
		id: 'sleep.account.loginFormHeadingDiscounted',
		defaultMessage:
			'Log in to unlock Calm Sleep for just <originalPrice></originalPrice> {currentPrice}, plus a 7-day free trial',
		description: 'The login form heading for discounted Calm Sleep Premium',
	},
	loginToggleText: {
		id: 'sleep.account.loginToggleText',
		defaultMessage: 'Don’t have an account?',
		description: 'The login toggle text for Calm Sleep Premium',
	},

	// Sign up
	signupFormHeading: {
		id: 'sleep.account.signupFormHeading',
		defaultMessage: 'Sign up to start feeling better today',
		description: 'The signup form heading for Calm Sleep Premium',
	},
	signupToggleText: {
		id: 'sleep.account.signupToggleText',
		defaultMessage: 'Have an account?',
		description: 'The signup toggle text for Calm Sleep Premium',
	},

	// Account
	accountSubheading: {
		id: 'sleep.account.subheading',
		defaultMessage:
			'7 Day Free Trial. Then Billed Yearly at {yearlyPrice}. Cancel anytime.<br></br><br></br>Currently only available for iOS users.',
		description: 'The subheading for Calm Sleep Premium',
	},
	accountSubheadingMonthly: {
		id: 'sleep.account.subheadingMonthly',
		defaultMessage:
			'Start with a 7 day free trial, then billed yearly at {yearlyPrice}. Or billed monthly starting today at {monthlyPrice}. Cancel anytime.<br></br><br></br>Currently only available for iOS users.',
		description: 'The subheading for Calm Sleep Premium',
	},
	accountSubheadingDiscounted: {
		id: 'sleep.account.subheadingDiscounted',
		defaultMessage:
			'The Calm Sleep discount is for current subscribers only. New subscribers can still start their 7-day free trial <a>here</a>.',
		description: 'The subheading for discounted Calm Sleep Premium',
	},

	// Value Props
	valuePropHeader: {
		id: 'sleep.account.valuePropHeader',
		defaultMessage: 'Unlock Calm Sleep Premium for FREE',
		description: 'Value props of Calm Sleep Premium',
	},
	valuePropHeaderDiscounted: {
		id: 'sleep.account.valuePropHeaderDiscounted',
		defaultMessage: 'Get 70% off Calm Sleep Premium',
		description: 'Value props of discounted Calm Sleep Premium',
	},
	valueProp1: {
		id: 'sleep.account.valueProp1',
		defaultMessage:
			'Fall asleep faster <regularWeight>with 500+ Sleep Stories, soundscapes, meditations and music</regularWeight>',
		description: 'Value Proposition to the user of benefits of Calm Sleep Premium',
	},
	valueProp2: {
		id: 'sleep.account.valueProp2',
		defaultMessage:
			'Get back to sleep quickly <regularWeight>with personalized content recommendations.</regularWeight>',
		description: 'Value Proposition to the user of benefits of Calm Sleep Premium',
	},
	valueProp3: {
		id: 'sleep.account.valueProp3',
		defaultMessage:
			'Quiet your mind <regularWeight>with expert-guided meditations for middle-of-night wake ups.</regularWeight>',
		description: 'Value Proposition to the user of benefits of Calm Sleep Premium',
	},

	// payment
	paymentHeading: {
		id: 'sleep.payment.heading',
		defaultMessage: 'Unlock all of Calm Sleep Premium with a 7 day free trial',
		description: 'The payment heading for Calm Sleep Premium',
	},
	paymentHeadingMonthly: {
		id: 'sleep.payment.headingMonthly',
		defaultMessage: 'Unlock all of Calm Sleep Premium',
		description: 'The payment heading for Calm Sleep Premium (monthly)',
	},
	paymentFormHeader: {
		id: 'sleep.payment.paymentFormHeader',
		defaultMessage: '1. Review your plan',
		description: 'The payment form header for Calm Sleep Premium',
	},
	trialTerms: {
		id: 'sleep.payment.trialTerms',
		defaultMessage:
			'By clicking "Start Your Trial", you agree to be automatically billed for Calm Sleep Premium at {price} after your trial ends and every year until cancelled. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for if user is starting free trial',
	},
	noTrialTerms: {
		id: 'sleep.payment.noTrialTerms',
		defaultMessage:
			'By clicking "Get Calm Sleep Premium", you agree to be automatically billed for Calm Sleep Premium at {price} monthly until cancelled. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for if user is subscribing without a free trial',
	},
	trialTermsDiscounted: {
		id: 'sleep.payment.trialTermsDiscounted',
		defaultMessage:
			'By clicking "Start Your Trial", you agree to be automatically billed at {price}/year for Calm Sleep Premium, which will renew every year until canceled. To be eligible for this offer you must have an active Calm Premium subscription. If your Calm Premium subscription has expired or been canceled when Calm Sleep Premium renews, you will be billed at the then-current price. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for if user is starting free trial',
	},
	trialEndTerms: {
		id: 'sleep.payment.trialEndTerms',
		defaultMessage:
			'7 days free, then {currentMonthlyPrice}/month, billed annually at {currentYearlyPrice} + applicable taxes/year.',
		description: 'Terms for if user is starting free trial with an offer',
	},
	ctaCopy: {
		id: 'sleep.payment.ctaCopy',
		defaultMessage: 'Get Calm Sleep Premium',
		description: 'The call-to-action copy for Calm Sleep Premium payment screen',
	},

	// handoff
	handoffHeading: {
		id: 'sleep.handoff.heading',
		defaultMessage: 'Welcome to Calm Sleep!',
		description: 'The handoff heading for Calm Sleep Premium',
	},
	handoffSubheading: {
		id: 'sleep.handoff.subheading',
		defaultMessage:
			'You’re in. Now download the Calm Sleep app to discover the full range of Calm Sleep’s features and benefits.',
		description: 'The handoff subheading for Calm Sleep Premium',
	},
	qrCodeInstructions: {
		id: 'sleep.handoff.qrCodeInstructions',
		defaultMessage: 'Scan this QR code to download Calm Sleep mobile app.',
		description: 'Instructions for scanning the QR code in the handoff screen',
	},

	// error
	ineligibleErrorHeading: {
		id: 'sleep.error.ineligibleErrorHeading',
		defaultMessage: 'Not a Calm Subscriber?',
		description: 'The heading for the ineligible error screen for Calm Sleep Premium',
	},
	ineligibleErrorSubheading: {
		id: 'sleep.error.ineligibleErrorSubheading',
		defaultMessage:
			'The Calm Sleep discount is for current subscribers only, but you can still begin your personalized sleep journey <a>here</a>.',
		description: 'The subheading for the ineligible error screen for Calm Sleep Premium',
	},
	ineligibleErrorCta: {
		id: 'sleep.error.ineligibleErrorCta',
		defaultMessage: 'Click here',
		description: 'The call-to-action for the ineligible error screen for Calm Sleep Premium',
	},

	// Custom SEO
	customSeoTitle: {
		id: 'sleep.customSeo.title',
		defaultMessage: 'Experience Calm Sleep',
		description: 'The custom search engine optimization (SEO) title for the Calm Sleep App signup page',
	},
	customSeoDescription: {
		id: 'sleep.customSeo.description',
		defaultMessage: 'Sign up for the Calm Sleep App to unlock premium features and content.',
		description: 'The custom search engine optimization (SEO) description for the Calm Sleep App signup page',
	},

	// Page Title
	pageTitle: {
		id: 'sleep.pageTitle',
		defaultMessage: 'Calm Sleep - App Signup',
		description: 'The page title for the Calm Sleep App signup page',
	},
});

export default messages;
